//src/Pages/Optical/DeviceAuthorization.js
import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { useTranslation } from 'react-i18next';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { fetchSessions, deleteSession } from '../../helpers/ApiRequests';

const DeviceAuthorization = ({ kc }) => { // Accept kc instance as a prop
                                          //const { kc } = useContext( KeycloakContext )
    const { t } = useTranslation();
    const [deviceCode, setDeviceCode] = useState('');
    const [sessions, setSessions] = useState([]);
    const toast = useRef(null);

    useEffect(() => {
        loadSessions();
    }, []);

    const loadSessions = async () => {
        try {
            const data = await fetchSessions(kc); // Pass kc to fetchSessions
            setSessions(data);
        } catch (error) {
            toast.current.show({ severity: 'error', summary: t('Error'), detail: t('Failed to load sessions') });
        }
    };

    const handleLinkHeadset = () => {
        if (deviceCode.length >= 8 && deviceCode.length <= 9) {
            const url = new URL(process.env.REACT_APP_KEYCLOAK_DEVICEAUTH_URL);
            url.searchParams.append('user_code', deviceCode);
            window.open(url.toString(), "_blank");
        } else {
            toast.current.show({ severity: 'error', summary: t('Error'), detail: t('Please enter a code between 8 and 9 digits') });
        }
    };

    const handleDeleteSession = async (sessionId) => {
        try {
            await deleteSession(kc, sessionId); // Pass kc to deleteSession
            toast.current.show({ severity: 'success', summary: t('Success'), detail: t('Session deleted successfully') });
            loadSessions(); // Refresh the session list
        } catch (error) {
            toast.current.show({ severity: 'error', summary: t('Error'), detail: t('Failed to delete session') });
        }
    };

    const formatDate = (timestamp) => {
        const date = new Date(timestamp);
        return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
    };

    const deleteButtonTemplate = (rowData) => {
        return (
            <Button
                icon="pi pi-trash"
                className="p-button-rounded p-button-danger"
                onClick={() => handleDeleteSession(rowData.id)}
                tooltip={t('DeleteSession')}
            />
        );
    };

    return (
        <div className="device-authorization text-center py-3 sm:py-4 my-3">
            <div className="p-field grid grid-cols-1 md:grid-cols-3 gap-2 m-0">
                <label className="text-left uppercase my-auto" htmlFor="deviceCode">{t('Glasses code')}</label>
                <InputText
                    id="deviceCode"
                    value={deviceCode}
                    onChange={(e) => setDeviceCode(e.target.value)}
                    placeholder={t('Glasses code')}
                    className="text-xs p-2 col-span-1 md:col-span-2 w-48 sm:60 md:w-72 lg:w-80 xl:w-80 2xl:w-96"
                />
                <div> </div>
                <Button className="text-center btn-1 mt-3 w-auto sm:w-1/4" onClick={handleLinkHeadset} label={t('Link glasses')} />
            </div>

            <Toast ref={toast} position="top-center" />

            <div className="mt-4">
                <h3>{t('LinkedHeadsets')}</h3>
                <DataTable value={sessions} responsiveLayout="scroll">
                    <Column field="id" header={t('SessionID')} />
                    <Column field="start" header={t('StartDate')} body={(rowData) => formatDate(rowData.start)} />
                    <Column field="lastAccess" header={t('LastAccessDate')} body={(rowData) => formatDate(rowData.lastAccess)} />
                    <Column body={deleteButtonTemplate} header={t('Actions')} />
                </DataTable>
            </div>
        </div>
    );
};

export default DeviceAuthorization;
